module.exports = __webpack_public_path__ + "static/media/Hearth House.bbe36151.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Hearth House.png
// module id = 67
// module chunks = 0